/**
 * A barra de baixo do painel no telemóvel: até cinco destinos com ícone e nome, alvos de
 * 56 px, por cima da zona segura do ecrã. O destino aceso leva a cor do portal.
 */
import React from "react";
import { Link } from "@inertiajs/react";
import { Icon } from "@iconify/react";
import { cn } from "@/lib/utils";

export interface DestinoBarra {
    chave: string;
    rotulo: string;
    icone: string;
    href?: string;
    onClick?: () => void;
    /** Abre a pesquisa ⌘K do painel (o `EstruturaPainel` liga-o sozinho). */
    abrePesquisa?: boolean;
    activo?: boolean;
    contagem?: number | string | null;
}

export function BarraInferior({ destinos }: { destinos: DestinoBarra[] }) {
    return (
        <nav
            data-tour="barra-inferior"
            aria-label="Navegação rápida"
            data-barra-inferior-painel
            className="fixed inset-x-0 bottom-0 z-40 border-t border-zinc-200 bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md md:hidden print:hidden dark:border-zinc-800 dark:bg-zinc-900/95"
        >
            <ul className="mx-auto flex max-w-lg items-stretch justify-around">
                {destinos.slice(0, 5).map((d) => {
                    const conteudo = (
                        <>
                            <span className="relative">
                                <Icon icon={d.icone} fontSize={24} />
                                {!!d.contagem && d.contagem !== "0" && (
                                    <span className="absolute -right-2 -top-1.5 flex min-w-[18px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-[18px] text-white ring-2 ring-white dark:ring-zinc-900">
                                        {d.contagem}
                                    </span>
                                )}
                            </span>
                            <span className="max-w-full truncate text-[11px] font-medium leading-none">{d.rotulo}</span>
                        </>
                    );
                    const classe = cn(
                        "flex h-14 w-full flex-col items-center justify-center gap-1 px-1 transition-colors",
                        d.activo ? "text-portal dark:text-portal-claro" : "text-zinc-500 active:text-zinc-900 dark:text-zinc-400",
                    );
                    return (
                        <li key={d.chave} className="min-w-0 flex-1">
                            {d.href ? (
                                <Link href={d.href} className={classe} aria-current={d.activo ? "page" : undefined}>
                                    {conteudo}
                                </Link>
                            ) : (
                                <button type="button" onClick={d.onClick} className={classe}>
                                    {conteudo}
                                </button>
                            )}
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
